import { logout } from './auth-api';

const escapeHtml = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');

export function renderCheckEmail(root: HTMLElement, email: string, onLogout: () => void): () => void {
  root.innerHTML = `
    <div class="min-h-dvh grid place-items-center px-5 py-10 bg-auth-gradient">
      <div class="w-full max-w-[420px] bg-auth-card border border-border rounded-lg p-8 shadow-lift text-center">
        <div class="mb-4 text-4xl">&#9993;</div>
        <h1 class="mb-2 font-heading text-2xl text-gold tracking-wide">Verify your email</h1>
        <p class="mb-6 text-sm text-text-dim">
          We sent a verification link to<br />
          <span class="text-text font-medium">${escapeHtml(email)}</span>
        </p>
        <p class="mb-6 text-sm text-text-dim">Check your inbox and click the link to continue.</p>
        <button type="button" id="check-email-logout"
          class="inline-block w-full p-3 bg-surface text-text-dim font-bold border border-border rounded transition-colors duration-[120ms] hover:bg-border hover:text-text cursor-pointer">
          Sign out
        </button>
      </div>
    </div>
  `;

  const btn = root.querySelector('#check-email-logout')!;
  const handler = async () => {
    await logout();
    onLogout();
  };
  btn.addEventListener('click', handler);
  return () => btn.removeEventListener('click', handler);
}
